// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-pic {
  height: 50vh;
  width: auto;
  object-fit: cover;
}
.mat-dialog-content {
  max-height: 100% !important;
  max-width: auto !important;
}

.circle {
  height: 35px;
  width: 35px;
  background-color: #eeecec !important;
  border: none !important;
  border-radius: 50%;
  color: #3b3b3b;
  font-size: 13px;
}

.circle:hover {
  background-color: #e4e4e4 !important;
  color: #000;
}
.f-15{
    font-size: 15px ;
}

.mb-lg{
    margin-bottom: 80px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/media-folders/manage-media/preview/preview.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".view-pic {\r\n  height: 50vh;\r\n  width: auto;\r\n  object-fit: cover;\r\n}\r\n.mat-dialog-content {\r\n  max-height: 100% !important;\r\n  max-width: auto !important;\r\n}\r\n\r\n.circle {\r\n  height: 35px;\r\n  width: 35px;\r\n  background-color: #eeecec !important;\r\n  border: none !important;\r\n  border-radius: 50%;\r\n  color: #3b3b3b;\r\n  font-size: 13px;\r\n}\r\n\r\n.circle:hover {\r\n  background-color: #e4e4e4 !important;\r\n  color: #000;\r\n}\r\n.f-15{\r\n    font-size: 15px ;\r\n}\r\n\r\n.mb-lg{\r\n    margin-bottom: 80px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
